import { useCallback } from 'react';
import { RequestAnalytics } from '../../components/stats';
import type { AnalyticsJob } from '../../components/stats';
import type { DateRange } from '../../types';
import { listAllHistoryJobs } from '../api';

/**
 * Video service Overview page — mirrors lightning's overview analytics,
 * wired to the video backend's history API.
 */
export function VideoOverviewPage() {
  const fetchAnalyticsJobs = useCallback(
    async (range: DateRange): Promise<AnalyticsJob[]> => {
      const jobs = await listAllHistoryJobs(range);
      return jobs.map((j) => ({
        id: j.job_id,
        scan_id: j.scan_id,
        created_at: j.created_at,
        status: j.status,
        duration_seconds: j.duration_seconds,
        error: j.error,
      }));
    },
    [],
  );

  return (
    <div className="flex flex-col gap-6 fit:min-h-0">
      {/* Request analytics */}
      <RequestAnalytics fetchJobs={fetchAnalyticsJobs} statsHref="/video/stats" />
    </div>
  );
}
